export const ITEMS_TYPES = {
  isSavedItem: "isSavedItem",
  isPersonItem: "isPersonItem",
  isNicheItem: "isNicheItem"
};
